module.exports = __webpack_public_path__ + "img/cmx-stats.140ac55b.webp";